




























import Vue, { PropType } from 'vue';
import { Subscription } from '~/services/BillingService';
import { dateToStringRaw } from '~/utils/dateToString';
import BaseCard from './BaseCard.vue';
import RenewButton from './RenewButton.vue';
import CancelButton from './CancelButton.vue';
import isAfter from 'date-fns/isAfter';
import differenceInDays from 'date-fns/differenceInDays';

export default Vue.extend({
    name: 'PlanDetailsCard',
    components: {
        BaseCard,
        RenewButton,
        CancelButton,
    },
    props: {
        subscription: {
            type: Object as PropType<Subscription>,
            required: true,
        },
    },
    computed: {
        headerText(): string {
            const tag = this.subscription.product.tags.find(tag => tag.key === 'type');
            const months = !tag ? 1 : tag.value === 'semester' ? 6 : 1;

            return this.$tc('plansAndBilling.planDetails.monthsAccess', months).toString();
        },
        subHeaderText(): string {
            return this.$t('plansAndBilling.planDetails.coursesAndProjects', {
                courses: '5000+',
                projects: '1900+',
            }).toString();
        },
        isExpired(): boolean {
            return isAfter(new Date(), this.subscription.expiresAt);
        },
        daysLeft(): string {
            const days = differenceInDays(this.subscription.expiresAt, new Date());
            return this.$tc('plansAndBilling.planDetails.daysLeft', days).toString();
        },
        renewsOnText(): string {
            const date = dateToStringRaw(this.subscription.expiresAt) || '';

            return this.$t('plansAndBilling.planDetails.renewsOn', {
                date,
            }).toString();
        },
    },
});
